import { ref } from 'vue';

type TState = 'rejected' | 'success' | 'pending' | undefined;
export const stakesDrawerState = ref<TState>(undefined);
